// RELEASE 新着情報: Figmaどおりつまみ高さ30px固定のカスタムスクロールバー
const THUMB_H = 30;

const syncThumb = (scrollEl, thumbEl) => {
    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    if (maxScroll <= 0) {
        thumbEl.style.transform = 'translateY(0)';
        return;
    }
    const trackTravel = scrollEl.clientHeight - THUMB_H;
    const ratio = scrollEl.scrollTop / maxScroll;
    thumbEl.style.transform = `translateY(${trackTravel * ratio}px)`;
};

const main = () => {
    const scrollEl = document.querySelector('.js-home-release-scroll');
    const thumbEl = document.querySelector('.js-home-release-thumb');
    if (!scrollEl || !thumbEl) return;

    const update = () => syncThumb(scrollEl, thumbEl);
    update();
    scrollEl.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
};

export default main;
